/* eslint-disable camelcase */
import { createAction } from '@reduxjs/toolkit';
import { CHAT_MESSAGES_INFO } from './messagingActions';
export const chatMessageInfo = createAction(CHAT_MESSAGES_INFO);
